import React from 'react';
import { Outlet } from 'react-router';
import './ProfileSettings.css';

function ProfileSettings() {
  return (
    <div className="full-page-layout">
      <div className="innerpage detailed-page profile-settings-page">
        <div className="page-header mb-4">
          <h1 className="page-title">My Profile</h1>
          <p className="page-subtitle">
            Manage your personal information and account settings
          </p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}

export default ProfileSettings;
